module.exports = __webpack_public_path__ + "img/sponsor_gallery_grid8.ff0e1bed.png";